import { render, staticRenderFns } from "./DdCustomButton.vue?vue&type=template&id=08fbc06b&scoped=true&"
import script from "./DdCustomButton.vue?vue&type=script&lang=js&"
export * from "./DdCustomButton.vue?vue&type=script&lang=js&"
import style0 from "./DdCustomButton.vue?vue&type=style&index=0&id=08fbc06b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fbc06b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
